<dm-sidebar variant="floating" collapsible="icon">
  <dm-sidebar-header>
    <div class="dm-flex dm-items-center dm-gap-8">
      <lp-logo variant="full" class="dm-sidebar-collapse-hide dm-flex-1" />
      <dm-tooltip
        class="lp-sidebar-navigation__trigger-wrap"
        label="Sidebar einklappen"
        i18n-label="@@sidebar.einklappen"
        placement="bottom"
      >
        <dm-sidebar-trigger>
          <dm-icon name="layout-left" />
        </dm-sidebar-trigger>
      </dm-tooltip>
    </div>
  </dm-sidebar-header>

  <dm-sidebar-content>
    <dm-sidebar-group>
      <dm-sidebar-menu>
        <dm-sidebar-menu-item>
          <dm-sidebar-menu-button
            icon="bar-chart-square-02"
            label="Dashboard"
            i18n-label="@@sidebar.dashboard"
            tooltip="Dashboard"
            i18n-tooltip="@@sidebar.dashboard"
            [routerLink]="sharedPath('DASHBOARD')"
            routerLinkActive
            #dashboardActive="routerLinkActive"
            [isActive]="dashboardActive.isActive"
          />
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item>
          <dm-sidebar-menu-button
            icon="scales-01"
            label="Compliance-Übersicht"
            i18n-label="@@sidebar.complianceUebersicht"
            tooltip="Compliance-Übersicht"
            i18n-tooltip="@@sidebar.complianceUebersicht"
            [routerLink]="'USER_COMPLIANCE_OVERVIEW' | userPath"
            routerLinkActive
            #complianceActive="routerLinkActive"
            [isActive]="complianceActive.isActive"
          />
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item [hidden]="!('USER_TASKS' | hasPermissionsForRoute)">
          <dm-sidebar-menu-button
            icon="check-done-01"
            label="Aufgaben"
            i18n-label="@@common.aufgaben"
            tooltip="Aufgaben"
            i18n-tooltip="@@common.aufgaben"
            [routerLink]="'USER_TASKS' | userPath"
            routerLinkActive
            #tasksActive="routerLinkActive"
            [isActive]="tasksActive.isActive"
          >
            <dm-badge slot="trailing" size="sm" color="gray">{{ aufgabenBadgeCounter() }}</dm-badge>
          </dm-sidebar-menu-button>
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item [hidden]="!('USER_REPORTS_ANALYSIS' | hasPermissionsForRoute)">
          <dm-sidebar-menu-button
            icon="pie-chart-03"
            label="Auswertungen"
            i18n-label="@@sidebar.auswertungen"
            tooltip="Auswertungen"
            i18n-tooltip="@@sidebar.auswertungen"
            [routerLink]="'AUSWERTUNGEN' | userPath"
            routerLinkActive
            #reportAnalysisActive="routerLinkActive"
            [isActive]="reportAnalysisActive.isActive"
          />
        </dm-sidebar-menu-item>

        <dm-sidebar-menu-item
          [hidden]="
            !('USER_ADMINISTRATION_USER_MANAGEMENT' | hasPermissionsForRoute) &&
            !('USER_ADMINISTRATION_LEXPLUS_CONFIG' | hasPermissionsForRoute)
          "
        >
          <dm-sidebar-collapsible label="Administration" i18n-label="@@sidebar.administration" icon="settings-02">
            <dm-sidebar-menu-sub-item [hidden]="!('USER_ADMINISTRATION_USER_MANAGEMENT' | hasPermissionsForRoute)">
              <dm-sidebar-menu-sub-button
                label="Benutzerverwaltung"
                i18n-label="@@sidebar.benutzerverwaltung"
                [routerLink]="'USER_ADMINISTRATION_USER_MANAGEMENT' | userPath"
                routerLinkActive
                #userManagementActive="routerLinkActive"
                [isActive]="userManagementActive.isActive"
              />
            </dm-sidebar-menu-sub-item>
            <dm-sidebar-menu-sub-item [hidden]="!('USER_ADMINISTRATION_LEXPLUS_CONFIG' | hasPermissionsForRoute)">
              <dm-sidebar-menu-sub-button
                label="Lexplus-Konfiguration"
                i18n-label="@@sidebar.lexplusKonfiguration"
                [routerLink]="'USER_ADMINISTRATION_LEXPLUS_CONFIG' | userPath"
                routerLinkActive
                #lexplusConfigActive="routerLinkActive"
                [isActive]="lexplusConfigActive.isActive"
              />
            </dm-sidebar-menu-sub-item>
          </dm-sidebar-collapsible>
        </dm-sidebar-menu-item>

        @if (isKundeDokumentManagerAktiv()) {
          <dm-sidebar-menu-item [hidden]="!('USER_DOCUMENT_MANAGER' | hasPermissionsForRoute)">
            <dm-sidebar-menu-button
              icon="file-04"
              label="Dokumenten-Manager"
              i18n-label="@@sidebar.dokumentenManager"
              tooltip="Dokumenten-Manager"
              i18n-tooltip="@@sidebar.dokumentenManager"
              [routerLink]="'USER_DOCUMENT_MANAGER' | userPath"
              routerLinkActive
              #documentManagerActive="routerLinkActive"
              [isActive]="documentManagerActive.isActive"
            />
          </dm-sidebar-menu-item>
        }

        <dm-sidebar-menu-item [hidden]="!('USER_DOWNLOADS' | hasPermissionsForRoute)">
          <dm-sidebar-menu-button
            icon="download-04"
            label="Downloads"
            i18n-label="@@sidebar.downloads"
            tooltip="Downloads"
            i18n-tooltip="@@sidebar.downloads"
            [routerLink]="'USER_DOWNLOADS' | userPath"
            routerLinkActive
            #downloadsActive="routerLinkActive"
            [isActive]="downloadsActive.isActive"
          />
        </dm-sidebar-menu-item>
      </dm-sidebar-menu>
    </dm-sidebar-group>
  </dm-sidebar-content>

  <dm-sidebar-footer>
    <dm-sidebar-group>
      <dm-sidebar-group-label label="Hilfe" i18n-label="@@sidebar.help" />
      <dm-sidebar-group-content>
        <dm-sidebar-menu>
          <dm-sidebar-menu-item>
            <dm-sidebar-menu-button
              icon="help-circle"
              label="FAQ"
              i18n-label="@@sidebar.faq"
              tooltip="FAQ"
              i18n-tooltip="@@sidebar.faq"
              [isActive]="faqOpen()"
              (click)="faqRequested.emit()"
            />
          </dm-sidebar-menu-item>
          <dm-sidebar-menu-item>
            <dm-sidebar-menu-button
              icon="life-buoy-01"
              label="Kontakt"
              i18n-label="@@sidebar.kontakt"
              tooltip="Kontakt"
              i18n-tooltip="@@sidebar.kontakt"
              [isActive]="kontaktOpen()"
              (click)="kontaktRequested.emit()"
            />
          </dm-sidebar-menu-item>
        </dm-sidebar-menu>
      </dm-sidebar-group-content>
    </dm-sidebar-group>

    <lp-account-menu [collapsed]="collapsed()" (logout)="logout()" />
    <lp-impersonation-selector [collapsed]="collapsed()" />
  </dm-sidebar-footer>
</dm-sidebar>
